<script setup lang="ts">
	import type { NuxtError } from '#app'

	const { error } = defineProps<{
		error: NuxtError
	}>()

	const is404 = computed(() => error.statusCode === 404)
	const isDev = import.meta.dev

	useSeoMeta({
		title: () => (is404.value ? 'Seite nicht gefunden' : 'Fehler'),
		robots: 'noindex, nofollow',
	})

	const handleError = () => clearError({ redirect: '/' })
</script>

<template>
	<NuxtLayout :title="is404 ? 'Seite nicht gefunden' : 'Fehler'">
		<GsPageSection
			class="py-20 min-h-screen"
			container-class="h-full flex flex-col items-center justify-center"
		>
			<Error404 v-if="is404" />

			<template v-else>
				<h1 class="text-primary">Ein Fehler ist aufgetreten</h1>
				<p class="mb-12">Bitte versuchen Sie es später erneut.</p>

				<pre v-if="isDev" class="mb-12 text-sm opacity-70">{{ error.statusCode }} – {{ error.message }}</pre>

				<GsBtn label="Zur Startseite" @click="handleError" />
			</template>
		</GsPageSection>
	</NuxtLayout>
</template>
